import { BusinessOutlined } from "@mui/icons-material";
import RffImportBorrowerEntitiesFromReduxButton from "../../components/finalForm/features/RffImportBorrowerEntitiesFromReduxButton";
import RffDateField from "../../components/finalForm/inputs/RffDateField";
import RffPercentField from "../../components/finalForm/inputs/RffPercentField";
import RffSelectAutocompleteField from "../../components/finalForm/inputs/RffSelectAutocompleteField";
import RffSelectField from "../../components/finalForm/inputs/RffSelectField";
import RffTextField from "../../components/finalForm/inputs/RffTextField";
import RffGroup from "../../components/finalForm/shared/RffGroup";
import { selectOptionsEntityType } from "../../constants/selectOptions/selectOptionsEntityType";
import { selectOptionsUsaStates } from "../../constants/selectOptions/selectOptionsUsaStates";
import TitledLoanSection from "./TitledLoanSection";

const BorrowingEntitiesSection = ({ returnChildrenOnly }) => {
  return (
    <TitledLoanSection
      variant="h2"
      returnChildrenOnly={returnChildrenOnly}
      headerEndContent={<RffImportBorrowerEntitiesFromReduxButton />}
      icon={<BusinessOutlined className="thin" />}
      title="Borrowing Entities"
    >
      <RffGroup suppressBottomMargin>
        <RffTextField name="borrowerEntity.entityName" label="Entity Name" />
        <RffPercentField
          name="borrowerEntity.applicantEntityPercentOwnership"
          label="What percentage ownership of the entity does the borrower have?"
          // label="What percentage ownership of borrower entity do you own?"
        />
        <RffSelectAutocompleteField
          size={4}
          name="borrowerEntity.entityStateOfOrganization"
          label="Entity State Of Organization"
          options={selectOptionsUsaStates}
        />
        <RffSelectField
          name="borrowerEntity.entityType"
          size={4}
          label="Entity Type"
          options={selectOptionsEntityType}
        />
        <RffDateField
          size={4}
          name="borrowerEntity.entityOrganizationDate"
          label="Entity Organization Date"
        />
      </RffGroup>
    </TitledLoanSection>
  );
};

export default BorrowingEntitiesSection;
